import React, { useState, useEffect } from 'react';
import Chart from '../../Components/Chart/Chart';
import Navbar from '../../Components/Navbar/Navbar';
import Sidebar from '../../Components/Sidebar/Sidebar';
import TableList from '../../Components/TableList/TableList';
import './Detail.scss';
import { useParams } from 'react-router-dom';
import axios from 'axios';

function Userdetail() {
    const { userId } = useParams(); // Accessing the userId parameter from the URL
    const [User, setUser] = useState("");
    const [lsat, setlsat] = useState("");
    const [success, setSuccess] = useState("");
    const [isChanged, setIsChanged] = useState(false);
    const [initialUser, setInitialUser] = useState(""); // Added state to store initial user data
    const [error, setError] = useState('');
    
    // Password state
    const [passwordData, setPasswordData] = useState({
        newPassword: '',
        confirmPassword: ''
    });
    const [showPasswordForm, setShowPasswordForm] = useState(false);
    
    const [formDataClient, setFormDataClient] = useState({
        dateRegistered: '',
        clientName: '',
        mobileNo: '',
        unitsBought: '',
        clientId: '',
        status: '',
        amountPaid: '',
        payments: '',
    });
    const [formDataTrans, setFormDataTrans] = useState({
        dateRegistered: '',
        clientName: '',
        mobileNo: '',
        property: '',
        referrerCid: '',
        referrerName: '',
        totalCost: '',
        amountPaid: '',
        balance: '',
    });
    const [formDataCommission, setFormDataCommission] = useState({
        dateReceived: '',
        directReferrer: '',
        cidNo: '',
        property: '',
        clientId: '',
        accountName: '',
        bank: '',
        accountNo: '',
        commissionPaid: '',
    });

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const response = await fetch(
                    `https://portal-sanieldanproperties-api.onrender.com/admin/users/${userId}`,
                ); // Adjust the API endpoint accordingly
                if (response.ok) {
                    const User = await response.json();
                    setUser(User);
                    console.log(User)
                    setInitialUser(User); // Store initial user data for change detection
                } else {
                    console.error('Failed to fetch user data:', response.status);
                }
            } catch (error) {
                console.error('Error fetching user data:', error);
            }
        };

        fetchUser();
    }, [userId]); // Fetch data whenever userId changes

    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${lsat}`,
        }
    };

    // Password change handler
    const handlePasswordChange = (e) => {
        const { name, value } = e.target;
        setPasswordData({ ...passwordData, [name]: value });
    };

    // Password update function
    const updatePassword = async () => {
        if (passwordData.newPassword !== passwordData.confirmPassword) {
            setError("Passwords don't match");
            setTimeout(() => setError(''), 5000);
            return;
        }

        if (passwordData.newPassword.length < 6) {
            setError("Password must be at least 6 characters long");
            setTimeout(() => setError(''), 5000);
            return;
        }

        try {
            const passwordUpdateData = {
                newPassword: passwordData.newPassword
            };

            await axios.put(
                `https://portal-sanieldanproperties-api.onrender.com/admin/update-user-password/${userId}`,
                passwordUpdateData, 
                config
            );
            
            setSuccess("Password updated successfully!");
            setPasswordData({ newPassword: '', confirmPassword: '' });
            setShowPasswordForm(false);
            
            setTimeout(() => {
                setSuccess("");
            }, 5000);
        } catch (error) {
            setError(error.response?.data?.error || 'Error updating password');
            console.log('Error updating password:', error);
            setTimeout(() => {
                setError("");
            }, 5000);
        }
    };

    const handleFormChangeClient = (e) => {
        const { name, value } = e.target;
        setFormDataClient({ ...formDataClient, [name]: value });
    };

    const handleFormChangeTrans = (e) => {
        const { name, value } = e.target;
        setFormDataTrans({ ...formDataTrans, [name]: value });
    };

    const handleFormChangeCommission = (e) => {
        const { name, value } = e.target;
        setFormDataCommission({ ...formDataCommission, [name]: value });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setUser({ ...User, [name]: value });

        // Check if the current value is different from the initial value
        if (value !== initialUser[name]) {
            setIsChanged(true); // If different, enable the button
        } else {
            setIsChanged(false); // If same, disable the button
        }
    };

    const updateUser = async () => {
        try {
            const updatedData = {
                balance: User.balance,
                totalrefferls: User.totalrefferls,
                paidreffers: User.paidreffers,
                unpaid: User.unpaid,
                totalpayouttrans: User.totalpayouttrans,
                totaltransactions: User.totaltransactions,
                clientList: User.clientList,
                userTransactions: User.userTransactions,
                paidCommissions: User.paidCommissions
            };

            await axios.put(
                `https://portal-sanieldanproperties-api.onrender.com/admin/update-user/${userId}`,
                updatedData, config
            );
            setInitialUser(User); // Update initialUser with the updated user data
            setIsChanged(false); // Reset isChanged to false after successful update
            // Show success message
            setSuccess(`${User.username} User data updated successfully!`);
            // Clear success message after 5 seconds
            setTimeout(() => {
                setSuccess("");
            }, 5000);
        } catch (error) {
            setError(error.response.data.error);
            console.log('Error updating user data:', error);
            // Handle error state or display error message to the user
            // Clear error message after 5 seconds
            setTimeout(() => {
                setError("");
            }, 5000);
        }
    };

    const referralCount = User?.referredUsers?.length || 0;

    const handleAddTransaction = async () => {
        const transactionData = {
            dateRegistered: formDataTrans.dateRegistered,
            clientName: formDataTrans.clientName,
            mobileNo: formDataTrans.mobileNo,
            property: formDataTrans.property,
            referrerCid: formDataTrans.referrerCid,
            referrerName: formDataTrans.referrerName,
            totalCost: formDataTrans.totalCost,
            amountPaid: formDataTrans.amountPaid,
            balance: formDataTrans.balance,
        };
        
        try {
            const response = await axios.post(`https://portal-sanieldanproperties-api.onrender.com/admin/transactions/${userId}`, transactionData, config);
            if (response.status === 201) {
                setSuccess('Transaction added successfully');
                setTimeout(() => setSuccess(''), 5000);
            }
        } catch (err) {
            setError(err.message);
            setTimeout(() => setError(''), 5000);
        }
    };

    const handleAddClient = async () => {
        const clientData = {
            dateRegistered: formDataClient.dateRegistered,
            clientName: formDataClient.clientName,
            mobileNo: formDataClient.mobileNo,
            unitsBought: formDataClient.unitsBought,
            clientId: formDataClient.clientId,
            status: formDataClient.status,
            amountPaid: formDataClient.amountPaid,
            payments: formDataClient.payments,
        };
        console.log(clientData)
        try {
            const response = await axios.post(
                `https://portal-sanieldanproperties-api.onrender.com/admin/clients/${User._id}`,
                clientData, config
            );
            if (response.status === 201) {
                setSuccess('Client added successfully');
                setTimeout(() => setSuccess(''), 5000);
            }
        } catch (err) {
            setError(err.message);
            console.log(err)
            setTimeout(() => setError(''), 5000);
        }
    };

    const handleAddPaidCommission = async () => {
        const commissionData = {
            dateReceived: formDataCommission.dateReceived,
            directReferrer: formDataCommission.directReferrer,
            cidNo: formDataCommission.cidNo,
            property: formDataCommission.property,
            clientId: formDataCommission.clientId,
            accountName: formDataCommission.accountName,
            bank: formDataCommission.bank,
            accountNo: formDataCommission.accountNo,
            commissionPaid: formDataCommission.commissionPaid,
        };
        try {
            const response = await axios.post(`https://portal-sanieldanproperties-api.onrender.com/admin/commissions/${userId}`, commissionData, config);
            if (response.status === 201) {
                setSuccess('Commission added successfully');
                setTimeout(() => setSuccess(''), 5000);
            }
        } catch (err) {
            setError(err.message);
            setTimeout(() => setError(''), 5000);
        }
    };

    return (
        <div className="details">
            <div className="home_sidebar">
                <Sidebar />
            </div>

            <div className="detail_page_main">
                <Navbar />

                <div className="pl-7 mt-2 flex mb-20 max-sm:flex-col">
                    {User && (
                        <div className="border p-3 shadow w-96">
                            <img src={User.image} alt="user" className="rounded " />
                            <div className="text-left">
                                <p className="flex justify-between py-2">Username: <span>{User.username}</span></p><hr />
                                <p className="flex justify-between py-2">FullName: <span>{User.firstName} {User.lastName}</span></p><hr />
                                <p className="flex justify-between py-2">Balance: <span>₦{User.balance}</span></p><hr />
                                <p className="flex justify-between py-2">Email: <span>{User.email}</span></p><hr />
                                <p className="flex justify-between py-2">Address: <span>{User.address}</span></p><hr />
                                <p className="flex justify-between py-2">City: <span>{User.city}</span></p><hr />
                                <p className="flex justify-between py-2">State: <span>{User.state}</span></p><hr />
                                <p className="flex justify-between py-2">Country: <span>{User.country}</span></p><hr />
                                <p className="flex justify-between py-2">PhoneNumber: <span>{User.phoneNumber}</span></p><hr />
                                <p className="flex justify-between py-2">Date Of Birth: <span>{User.dob}</span></p><hr />
                                <p className="flex justify-between py-2">Gender: <span>{User.gender}</span></p><hr />
                                <p className="flex justify-between py-2">Account Details:</p>
                                <ul className='ml-3'>
                                    {User.acctdetails && User.acctdetails.map((detail, index) => (
                                        <li key={index}>
                                            <p className='flex justify-between py-2 '>BankName: <span>{detail.bankName}</span></p><hr />
                                            <p className='flex justify-between py-2 '>Account Number: <span>{detail.bankNumber}</span></p><hr />
                                            <p className='flex justify-between py-2'>Owner FullName: <span>{detail.bankFullName}</span></p><hr />
                                        </li>
                                    ))}
                                </ul>
                                 <div className="flex justify-between py-2">
                                  <p >Referred Users:</p>
                                      <ul className='ml-3' style={{listStyleType: "disc"}}>
                                        {User.referredUsers && User.referredUsers.map((user, index) => (
                                          <li key={index} className='flex justify-between py-2'>{user}</li>
                                        ))}
                                      </ul>
                                 </div>
                                    <hr />
                                    <p className="flex justify-between py-2">Referred By:</p>
                                    <ul className='ml-3'>
                                      <li className='flex justify-between py-2'>First Name: <span>{User.referredby.firstName}</span></li><hr />
                                      <li className='flex justify-between py-2'>Last Name: <span>{User.referredby.lastName}</span></li><hr />
                                      <li className='flex justify-between py-2'>Phone Number: <span>{User.referredby.phoneNumber}</span></li><hr />
                                    </ul>
                                
                                <h2 className="font-semibold text-lg dark:text-white mt-20">Client List</h2>
                                                                                  
                                <div class="relative overflow-x-auto">
                                    <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                                        <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                                            <tr>
                                                <th scope="col" class="px-6 py-3">
                                                Date Reg
                                                </th>
                                                <th scope="col" class="px-6 py-3">
                                                Client Name
                                                </th>
                                                <th scope="col" class="px-6 py-3">
                                                Mobile No
                                                </th>
                                                <th scope="col" class="px-6 py-3">
                                                Units bought
                                                </th>
                                                <th scope="col" class="px-6 py-3">
                                                Client ID
                                                </th>
                                                <th scope="col" class="px-6 py-3">
                                                Status
                                                </th>
                                                <th scope="col" class="px-6 py-3">
                                                Payments
                                                </th>
                                              
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {User.clientList && User.clientList.map((client, index) => (
                                            <tr key={index} class="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                                                <td class="px-6 py-4">
                                                {client.dateRegistered}
                                                </td>
                                                <td class="px-6 py-4">
                                                {client.clientName}
                                                </td>
                                                <td class="px-6 py-4">
                                                {client.mobileNo}
                                                </td>
                                                <td class="px-6 py-4">
                                                {client.property}
                                                </td>
                                                <td class="px-6 py-4">
                                                {client.unitsBought}
                                                </td>
                                                <td class="px-6 py-4">
                                                  {client.clientId}
                                                </td>
                                                <td class="px-6 py-4">
                                                {client.status}
                                                </td>
                                                <td class="px-6 py-4">
                                                {client.amountPaid}
                                                </td>
                                                <td class="px-6 py-4">
                                                {client.payments}
                                                </td>
                                            </tr>    
                                          ))}
                                        </tbody>
                                    </table>                               
                                </div>

                                {/* User Transactions Section */}
                                <h2 className="font-semibold text-lg dark:text-white mt-7">User Transactions</h2>                               
                                <div class="relative overflow-x-auto">
                                    <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                                        <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                                            <tr>
                                                <th scope="col" class="px-6 py-3">
                                                Date Reg
                                                </th>
                                                <th scope="col" class="px-6 py-3">
                                                Client Name
                                                </th>
                                                <th scope="col" class="px-6 py-3">
                                                Mobile No
                                                </th>
                                                <th scope="col" class="px-6 py-3">
                                                Property
                                                </th>
                                                <th scope="col" class="px-6 py-3">
                                                Referrer CID
                                                </th>
                                                <th scope="col" class="px-6 py-3">
                                                Referrer Name
                                                </th>
                                                <th scope="col" class="px-6 py-3">
                                                Total Cost
                                                </th>
                                                <th scope="col" class="px-6 py-3">
                                                Amount Paid
                                                </th>
                                                <th scope="col" class="px-6 py-3">
                                                Balance
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {User.userTransactions && User.userTransactions.map((trans, index) => (
                                            <tr key={index} class="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                                                <td class="px-6 py-4">
                                                {trans.dateRegistered}
                                                </td>
                                                <td class="px-6 py-4">
                                                {trans.clientName}
                                                </td>
                                                <td class="px-6 py-4">
                                                {trans.mobileNo}
                                                </td>
                                                <td class="px-6 py-4">
                                                {trans.property}
                                                </td>
                                                <td class="px-6 py-4">
                                                {trans.referrerCid}
                                                </td>
                                                <td class="px-6 py-4">
                                                  {trans.referrerName}
                                                </td>
                                                <td class="px-6 py-4">
                                                {trans.totalCost}
                                                </td>
                                                <td class="px-6 py-4">
                                                {trans.amountPaid}
                                                </td>
                                                <td class="px-6 py-4">
                                                {trans.balance}
                                                </td>
                                            </tr>    
                                          ))}
                                        </tbody>
                                    </table>                               
                                </div>
                                

                                {/* Paid Commissions Section */}
                                <h2 className="font-semibold text-lg dark:text-white mt-7">Successfully Paid Commissions</h2>
                                <div class="relative overflow-x-auto">
                                    <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                                        <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                                            <tr>
                                                <th scope="col" class="px-6 py-3">
                                                Date Received
                                                </th>
                                                <th scope="col" class="px-6 py-3">
                                                Direct Referrer
                                                </th>
                                                <th scope="col" class="px-6 py-3">
                                                CID No
                                                </th>
                                                <th scope="col" class="px-6 py-3">
                                                Property
                                                </th>
                                                <th scope="col" class="px-6 py-3">
                                                Client ID
                                                </th>
                                                <th scope="col" class="px-6 py-3">
                                                Account Name
                                                </th>
                                                <th scope="col" class="px-6 py-3">
                                                Bank
                                                </th>
                                                <th scope="col" class="px-6 py-3">
                                                Account no
                                                </th>
                                                <th scope="col" class="px-6 py-3">
                                                Commission paid
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {User.successfulPaidCommissions && User.successfulPaidCommissions.map((commissions, index) => (
                                            <tr key={index} class="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                                                <td class="px-6 py-4">
                                                {commissions.dateReceived}
                                                </td>
                                                <td class="px-6 py-4">
                                                {commissions.directReferrer}
                                                </td>
                                                <td class="px-6 py-4">
                                                {commissions.cidNo}
                                                </td>
                                                <td class="px-6 py-4">
                                                {commissions.transactionAmount}
                                                </td>
                                                <td class="px-6 py-4">
                                                {commissions.transactionType}
                                                </td>
                                                <td class="px-6 py-4">
                                                  {commissions.transactionDescription}
                                                </td>
                                               
                                            </tr>    
                                          ))}
                                        </tbody>
                                    </table>                               
                                </div>
                            </div>
                        </div>
                    )}

                    <div className='w-2/3 p-3 border shadow ml-10 max-sm:w-96 max-sm:ml-0 max-sm:mt-3'>
                        {error && (
                            <div id="pop-up" style={{ zIndex: 9999, borderTopWidth: "6px" }} className="fixed border-red-600 shadow-xl bg-white mt-24 xl:mt-28 mr-4 max-w-xs top-0 right-0 py-2 px-3">
                                <h2 className="font-bold tracking-wider">Profile Update Failed</h2>
                                <p className="text-sm text-left tracking-wider pt-1">{error}</p>
                            </div>
                        )}

                        {success && (
                            <div id="pop-up" style={{ zIndex: 9999, borderTopWidth: "6px" }} className="fixed border-green-600 shadow-xl bg-white mt-24 xl:mt-28 mr-4 max-w-xs top-0 right-0 py-2 px-3">
                                <h2 className="font-bold tracking-wider">Data updated successfully</h2>
                                <p className="text-sm text-left tracking-wider pt-1">{success}</p>
                            </div>
                        )}

                        <h1 className="text-left mb-10 font-semibold text-xl dark:text-white">Edit {User.username} Account</h1>

                        <div>
                            {/* Password Change Section */}
                            <div className='mt-5'>
                                <button 
                                    onClick={() => setShowPasswordForm(!showPasswordForm)}
                                    className="py-2 px-4 rounded bg-yellow-500 hover:bg-yellow-700 text-white font-bold mb-5"
                                >
                                    {showPasswordForm ? 'Cancel Password Change' : 'Change Password'}
                                </button>

                                {showPasswordForm && (
                                    <div className="border p-4 rounded mb-5 bg-gray-50 dark:bg-gray-800">
                                        <h2 className="font-semibold text-lg dark:text-white mb-3">Change Password</h2>
                                        <div className="mt-3 flex-col text-left">
                                            <label htmlFor="newPassword" className="dark:text-white">New Password</label><br />
                                            <input 
                                                required 
                                                type="password" 
                                                name="newPassword" 
                                                className="input w-full p-2 border rounded mt-1" 
                                                value={passwordData.newPassword}
                                                onChange={handlePasswordChange}
                                                placeholder="Enter new password"
                                            /><br />
                                            <label htmlFor="confirmPassword" className="dark:text-white mt-3">Confirm Password</label><br />
                                            <input 
                                                required 
                                                type="password" 
                                                name="confirmPassword" 
                                                className="input w-full p-2 border rounded mt-1" 
                                                value={passwordData.confirmPassword}
                                                onChange={handlePasswordChange}
                                                placeholder="Confirm new password"
                                            /><br />
                                            <button 
                                                onClick={updatePassword}
                                                className="mt-3 py-2 px-4 rounded bg-green-500 hover:bg-green-700 text-white font-bold"
                                            >
                                                Update Password
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div className='flex justify-between max-sm:flex-col'>
                                <div className="mt-5 flex-col text-left">
                                    <label htmlFor="balance" className="dark:text-white">Balance</label><br />
                                    <input required type="text" name="balance" className="input" value={User.balance} onChange={handleInputChange} />
                                </div>
                            </div>

                            {/* Add Client Section */}
                            <div className='mt-10'>
                                <h2 className="font-semibold text-lg dark:text-white">Add Client</h2>
                                <div className="mt-5 flex-col text-left">
                                  <form>
                                  <label htmlFor="dateRegistered" className="dark:text-white">Date Registered</label><br />
                                <input required type="date" name="dateRegistered" className="input" onChange={handleFormChangeClient} /><br />
                                <label htmlFor="clientName" className="dark:text-white">Client Name</label><br />
                                <input required type="text" name="clientName" className="input" onChange={handleFormChangeClient} /><br />
                                <label htmlFor="mobileNo" className="dark:text-white">Mobile No</label><br />
                                <input required type="text" name="mobileNo" className="input" onChange={handleFormChangeClient} /><br />
                                <label htmlFor="unitsBought" className="dark:text-white">Units bought</label><br />
                                <input required type="text" name="unitsBought" className="input" onChange={handleFormChangeClient} /><br />
                                <label htmlFor="clientId" className="dark:text-white">Client ID</label><br />
                                <input required type="number" name="clientId" className="input" onChange={handleFormChangeClient} /><br />
                                <label htmlFor="status" className="dark:text-white">Status</label><br />
                                <input required type="text" name="status" className="input" onChange={handleFormChangeClient} /><br />
                                <label htmlFor="amountPaid" className="dark:text-white">Amount Paid</label><br />
                                <input required type="number" name="amountPaid" className="input" onChange={handleFormChangeClient} /><br />
                                <label htmlFor="payments" className="dark:text-white">Payments</label><br />
                                <input required type="number" name="payments" className="input" onChange={handleFormChangeClient} /><br />
                                    </form>
                                    <button className="mt-5 py-2 px-4 rounded bg-blue-500 hover:bg-blue-700 text-white font-bold" onClick={handleAddClient}>
                                        Add Client
                                    </button>
                                </div>
                            </div>

                            {/* Add Transaction Section */}
                            <div className='mt-10'>
                                <h2 className="font-semibold text-lg dark:text-white">Add Transaction</h2>
                                <div className="mt-5 flex-col text-left">
                                    <label htmlFor="dateRegistered" className="dark:text-white">  Date Reg</label><br />
                                    <input required type="date" name="dateRegistered" className="input" onChange={handleFormChangeTrans}  /><br />
                                    <label htmlFor="clientName" className="dark:text-white">Client Name</label><br />
                                    <input required type="text" name="clientName" className="input" onChange={handleFormChangeTrans} /><br />
                                    <label htmlFor="mobileNo" className="dark:text-white">Mobile No</label><br />
                                    <input required type="text" name="mobileNo" className="input" onChange={handleFormChangeTrans} /><br />
                                    <label htmlFor="property" className="dark:text-white">Property</label><br />
                                    <input required type="text" name="property" className="input" onChange={handleFormChangeTrans} /><br />
                                    <label htmlFor="referrerCid" className="dark:text-white">Referrer CID</label><br />
                                    <input required type="text" name="referrerCid" className="input" onChange={handleFormChangeTrans} /><br />
                                    <label htmlFor="referrerName" className="dark:text-white">Referrer Name</label><br />
                                    <input required type="text" name="referrerName" className="input" onChange={handleFormChangeTrans} /><br />
                                    <label htmlFor="totalCost" className="dark:text-white">Total Cost</label><br />
                                    <input required type="text" name="totalCost" className="input" onChange={handleFormChangeTrans} /><br />
                                    <label htmlFor="amountPaid" className="dark:text-white">  Amount Paid</label><br />
                                    <input required type="text" name="amountPaid" className="input" onChange={handleFormChangeTrans} /><br />
                                    <label htmlFor="balance" className="dark:text-white">Balance</label><br />
                                    <input required type="text" name="balance" className="input" onChange={handleFormChangeTrans} /><br />
                                    <button className="mt-5 py-2 px-4 rounded bg-blue-500 hover:bg-blue-700 text-white font-bold" onClick={handleAddTransaction}>
                                        Add Transaction
                                    </button>
                                </div>
                            </div>

                            {/* Add Paid Commission Section */}
                            <div className='mt-10'>
                                <h2 className="font-semibold text-lg dark:text-white">Add Paid Commission</h2>
                                <div className="mt-5 flex-col text-left">
                                    <label htmlFor="dateReceived" className="dark:text-white">Date Received</label><br />
                                    <input required type="date" name="dateReceived" className="input" onChange={handleFormChangeCommission} /><br />
                                    <label htmlFor="directReferrer" className="dark:text-white">Direct Referrer</label><br />
                                    <input required type="text" name="directReferrer" className="input" onChange={handleFormChangeCommission} /><br />
                                    <label htmlFor="cidNo" className="dark:text-white">CID No</label><br />
                                    <input required type="text" name="cidNo" className="input" onChange={handleFormChangeCommission} /><br />
                                    <label htmlFor="property" className="dark:text-white">Property</label><br />
                                    <input required type="text" name="property" className="input" onChange={handleFormChangeCommission}  /><br />
                                    <label htmlFor="clientId" className="dark:text-white">Client ID</label><br />
                                    <input required type="text" name="clientId" className="input" onChange={handleFormChangeCommission}  /><br />
                                    <label htmlFor="accountName" className="dark:text-white">Account Name</label><br />
                                    <input required type="text" name="accountName" className="input" onChange={handleFormChangeCommission} /><br />
                                    <label htmlFor="bank" className="dark:text-white">Bank</label><br />
                                    <input required type="text" name="bank" className="input" onChange={handleFormChangeCommission} /><br />
                                    <label htmlFor="accountNo" className="dark:text-white">Account No</label><br />
                                    <input required type="text" name="accountNo" className="input" onChange={handleFormChangeCommission} /><br />
                                    <label htmlFor="commissionPaid" className="dark:text-white">Commission Paid</label><br />
                                    <input required type="number" name="commissionPaid" className="input" onChange={handleFormChangeCommission} /><br />
                                    <button className="mt-5 py-2 px-4 rounded bg-blue-500 hover:bg-blue-700 text-white font-bold" onClick={handleAddPaidCommission}>
                                        Add Paid Commission
                                    </button>
                                </div>
                            </div>

                            <div className="mt-10">
                                <button onClick={updateUser} disabled={!isChanged} className="py-2 px-4 rounded bg-blue-500 hover:bg-blue-700 text-white font-bold disabled:opacity-50 disabled:cursor-not-allowed">
                                    Save Changes
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

          
        </div>
    );
}

export default Userdetail;
